import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/magicLIVING_white.png';

const Home = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-primary to-secondary text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
                Innovative WEG-Verwaltung mit KI-Unterstützung
              </h1>
              <p className="text-xl mb-8 text-blue-100">
                Verlässlich, DSGVO-konform und ausschließlich in Deutschland gehostet. 
                Wir unterstützen Sie bei der professionellen Verwaltung Ihrer Wohnungseigentümergemeinschaft.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <Link to="/kontakt" className="btn-primary text-center">
                  Angebot anfragen
                </Link>
                <Link to="/leistungen" className="bg-white text-secondary px-6 py-3 rounded-lg font-medium hover:bg-gray-100 transition-colors duration-200 text-center">
                  Unsere Leistungen
                </Link>
              </div>
            </div>
            <div className="flex justify-center lg:justify-end">
              <img 
                src={logo} 
                alt="magicLIVING Logo" 
                className="w-80 h-auto drop-shadow-2xl"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Key Messages Section */}
      <section className="py-20 bg-background">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-secondary mb-4">
              Warum magicLIVING?
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Wir bieten Ihnen eine Kombination aus lokalem, persönlichem Ansprechpartner und digitaler Effizienz – maßgeschneidert für kleine Eigentümergemeinschaften.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Verlässlichkeit */}
            <div className="card text-center">
              <div className="w-16 h-16 bg-primary rounded-full flex items-center justify-center mx-auto mb-6">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-secondary mb-4">Verlässlichkeit in der WEG-Verwaltung</h3>
              <p className="text-gray-600">
              Wir kombinieren traditionelle Verlässlichkeit mit modernster Technologie 
              für eine effiziente und transparente WEG-Verwaltung. Künstliche Intelligenz unterstützt bei Kommunikation, Datenanalyse 
                und Automatisierung für effizientere Verwaltungsprozesse.
              </p>
            </div>

            {/* KI-Technologie */}
            <div className="card text-center">
              <div className="w-16 h-16 bg-secondary-light rounded-full flex items-center justify-center mx-auto mb-6">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-secondary mb-4">Kosteneffektiv auch für kleine Wohnungseigentümer Gemeinschaften</h3>
              <p className="text-gray-600">
                Seit der WEG-Reform 2024 sind Eigentümergemeinschaften mit 9 oder mehr Einheiten gesetzlich verpflichtet, einen externen Verwalter zu bestellen. 
                Jedoch finden kleine Gemeinschaften kaum bezahlbare und zuverlässige Hausverwaltungen. Während viele große Verwalter kleine Objekte ablehnen, füllt magicLIVING gezielt diese Lücke.
              </p>
            </div>

            {/* DSGVO-Konformität */}
            <div className="card text-center">
              <div className="w-16 h-16 bg-secondary rounded-full flex items-center justify-center mx-auto mb-6">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-secondary mb-4">DSGVO-Konformität, Datensparsamkeit & Deutsches Hosting</h3>
              <p className="text-gray-600">
                Alle Daten werden ausschließlich in Deutschland gehostet und 
                streng nach DSGVO-Richtlinien verarbeitet und geschützt. Dabei setzen wir auf zertifizierte Rechenzentren mit modernster Verschlüsselungstechnologie und gewährleisten, dass personenbezogene Daten weder an Dritte weitergegeben noch außerhalb der EU übertragen werden.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Vorteile Section */}
      <section className="py-20 bg-background-secondary">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-secondary mb-4">
              Ihre Vorteile
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Als Wohneigentumsgemeinschaft profitieren Sie von unserer innovativen 
              und verlässlichen Verwaltungslösungen.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="space-y-6">
              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0 w-6 h-6 bg-primary rounded-full flex items-center justify-center mt-1">
                  <div className="w-2 h-2 bg-white rounded-full"></div>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-secondary mb-2">Transparente Kommunikation</h3>
                  <p className="text-gray-600">Klare und regelmäßige Informationen über alle wichtigen Verwaltungsentscheidungen und -prozesse. Nachvollziehbar und ohne Fachchinesisch!</p>
                </div>
              </div>
              
              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0 w-6 h-6 bg-primary rounded-full flex items-center justify-center mt-1">
                  <div className="w-2 h-2 bg-white rounded-full"></div>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-secondary mb-2">Kosteneffizienz</h3>
                  <p className="text-gray-600">Durch den Einsatz intelligenter Tools und KI-gestützter Prozesse senken wir Verwaltungsaufwände und schaffen ein exzellentes Preis-Leistungs-Verhältnis.</p>
                </div>
              </div>
              
              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0 w-6 h-6 bg-primary rounded-full flex items-center justify-center mt-1">
                  <div className="w-2 h-2 bg-white rounded-full"></div>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-secondary mb-2">Professionelle Verwaltung</h3>
                  <p className="text-gray-600">Alle Vorgänge in der WEG-Verwaltung werden professionell, gesetzeskonform und stets auf dem aktuellen Stand der Rechtsprechung umgesetzt – inklusive WEG-Reform 2024.</p>
                </div>
              </div>
            </div>

            <div className="space-y-6">
              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0 w-6 h-6 bg-primary rounded-full flex items-center justify-center mt-1">
                  <div className="w-2 h-2 bg-white rounded-full"></div>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-secondary mb-2">Digitale Verwaltung</h3>
                  <p className="text-gray-600">Moderne Online-Tools für einfache Dokumentenverwaltung und Kommunikation. Behalten Sie den Überblick: verwalten Sie Ihre Dokumente, Termine und Informationen bequem von überall.</p>
                </div>
              </div>
              
              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0 w-6 h-6 bg-primary rounded-full flex items-center justify-center mt-1">
                  <div className="w-2 h-2 bg-white rounded-full"></div>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-secondary mb-2">24/7 Verfügbarkeit</h3>
                  <p className="text-gray-600">Wichtige Unterlagen und Mitteilungen sind für Sie rund um die Uhr digital verfügbar – unabhängig von Bürozeiten.</p>
                </div>
              </div>
              
              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0 w-6 h-6 bg-primary rounded-full flex items-center justify-center mt-1">
                  <div className="w-2 h-2 bg-white rounded-full"></div>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-secondary mb-2">Persönlicher Service</h3>
                  <p className="text-gray-600">Direkter Kontakt zu Ihrem persönlichen Ansprechpartner bei Fragen und Anliegen. Sie sprechen nicht mit einem Chatbot oder Callcenter. Bei magicLIVING haben Sie einen festen Ansprechpartner, der Ihre Immobilie und Ihre Anliegen kennt.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-primary">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            Bereit für die Zukunft der WEG-Verwaltung?
          </h2>
          <p className="text-xl text-blue-100 mb-8">
            Lassen Sie uns gemeinsam Ihre Wohnungseigentümergemeinschaft 
            professionell und zukunftsorientiert verwalten.
          </p>
          <Link to="/kontakt" className="bg-white text-primary px-8 py-4 rounded-lg font-semibold hover:bg-gray-100 transition-colors duration-200 inline-block">
            Jetzt unverbindliches Angebot anfragen
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Home; 